import { OverridedMixpanel } from "mixpanel-browser";
import { createContext } from "react";

const MixpanelContext = createContext<OverridedMixpanel | null>(null);

export { MixpanelContext };